import { PageContainerWithoutBackground } from '../PageContainerWithoutBackground';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

export const ForeverSpinnerLayout = observer(function ForeverSpinnerLayout() {
	return (
		<PageContainerWithoutBackground>
			<Suspense fallback={null}>
				<Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
				<Outlet />
			</Suspense>
		</PageContainerWithoutBackground>
	);
});
